export default __webpack_public_path__ + "static/media/4.f68b4fa6.png";